import io from "socket.io-client";
import config from "../config";

export default function socketMiddleware() {
  const socket = io(config.app.fullUrl, {
    transports: ["websocket", "polling"],
  });
  const ON = "ON";
  const EMIT = "EMIT";
  const EMIT_ROOM = "EMIT_ROOM";

  return ({ dispatch }) =>
    (next) =>
    (action) => {
      if (typeof action === "function") {
        return next(action);
      }

      const { event, leave, handle, room, type, ...rest } = action;

      if (!event) {
        return next(action);
      }

      if (leave) {
        return socket.removeListener(event);
      }

      switch (type) {
        case ON: {
          return socket.on(event, handle);
        }
        case EMIT: {
          return socket.emit(event, handle);
        }
        case EMIT_ROOM: {
          return socket.in(room).emit(event, handle);
        }
      }
    };
}
